import React from 'react';
import { injectIntl } from 'react-intl';
import { SubmitButton } from '@fortress-technology-solutions/fortress-component-library/Atoms';

import ElementWithPermissions from '../../../../../../components/ElementWithPermissions';

import messages from './messages';

type Props = {
  canComplete: boolean,
  handleSubmit: Function,
  intl: Object,
  onSubmit: Function,
  disable: boolean,
  submitting: boolean,
};

export const UnselectedMethodSaveButton = ({
  canComplete,
  handleSubmit,
  intl,
  onSubmit,
  disable,
  submitting,
}: Props) => {
  return (
    <ElementWithPermissions scope={['lease-create']}>
      <SubmitButton
        sx={{ width: 200 }}
        variant={'primarySubtle'}
        isSubmitting={submitting}
        disabled={!canComplete || disable || submitting}
        onClick={handleSubmit(onSubmit)}
      >
        {intl.formatMessage(messages.save)}
      </SubmitButton>
    </ElementWithPermissions>
  );
};

export default injectIntl(UnselectedMethodSaveButton);
